export default class Base64Encoder  {
  static encode(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = error => reject(error);
    });
  }
}


// WEBPACK FOOTER //
// ./src/services/encoders/Base64Encoder.tsx